module.exports = __webpack_public_path__ + "static/media/Challenge Accepted.f6159723.jpg";